import React from 'react';
import ParticipantStrip from '../ParticipantStrip/ParticipantStrip';
import {styled} from '@material-ui/core/styles';

const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
}));

export default function Room() {
  return (
    <Container>
      <ParticipantStrip />
    </Container>
  );
}
